/** Match the resource/action scopes returned for the current administrator. */
export function hasSupporterPermission(
  scopes: string[] = [],
  required: string
): boolean {
  const [resource, action] = required.toLowerCase().split(':');
  return scopes.some((scope) => {
    const [scopeResource, actions = ''] = scope.toLowerCase().split(':');
    return (
      (scopeResource === resource || scopeResource === '*') &&
      (actions === '*' || actions.includes(action))
    );
  });
}
